import { render, staticRenderFns } from "./BulkFamilyAssigner.vue?vue&type=template&id=b5ed7938&scoped=true"
import script from "./BulkFamilyAssigner.vue?vue&type=script&lang=js"
export * from "./BulkFamilyAssigner.vue?vue&type=script&lang=js"
import style0 from "./BulkFamilyAssigner.vue?vue&type=style&index=0&id=b5ed7938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ed7938",
  null
  
)

export default component.exports